import { FC } from 'react'
import { SiteModel } from '../../../core/_models'
type Props = {
  site: SiteModel
}
const DefectLiabilityPeriodFinalAcceptance: FC<Props> = ({ site }) => {

  return (
    <div className='d-flex align-items-center'>
      {site.finalAcceptanceTechnicalInspectionRemedyDefectsAndCertifications}
    </div>
  )
}
export { DefectLiabilityPeriodFinalAcceptance }
